export default __webpack_public_path__ + "static/media/LANCIA.a73f9974.png";